// extracted by mini-css-extract-plugin
export default {"root":"CvzagfrW","errorContainer":"vqPyktiT","errorCode":"f3u59qJr","errorMessage":"yULGJosq","errorRobot":"r302jeK9","errorBackground":"zsHVki5e","errorGround":"iTryRmp0"};